import CityPageTemplate from "../city-template/CityPageTemplate";
import { centrevilleVaConfig } from "./data";

export default function CentrevilleVaPage() {
  return <CityPageTemplate config={centrevilleVaConfig} />;
}